// Components
import Modal from '../../../../Modal'

// Utilities
import { useAuthContext } from '../../../../../context/index'
import { titleCase } from 'utils'
import { settings } from 'settings'

const InfoModal = props => {
  // Props
  const {
    pages,
    book,
    openInfoModal,
    handleCloseInfoModal,
    difficulty,
    gridTags,
    source,
    gridId,
    gridSubject,
    createdByCurrentUser,
  } = props

  const { userDetails } = useAuthContext()

  return (
    <Modal
      title={'Detalii grilă'}
      isOpen={openInfoModal}
      closeModal={handleCloseInfoModal}
      width={'400px'}
    >
      <div className="mt-[20px] text-over-primary-background info-modal">
        {createdByCurrentUser && <p>Grila a fost creată de tine</p>}

        {gridSubject && (
          <p>
            {titleCase(settings.materie)}:{' '}
            <span className="font-bold">{gridSubject}</span>
          </p>
        )}

        <p className="text-base">
          Capitol:{' '}
          <span className="font-bold">{gridTags?.slice(0, 2).join(', ')}</span>
        </p>

        {difficulty && (
          <p className="text-base">
            Dificultate: <span className="font-bold">{difficulty}</span>
          </p>
        )}

        {source && (
          <p className="text-base">
            Sursă: <span className="font-bold">{source}</span>
          </p>
        )}

        {pages && (
          <p className="text-base tutorial-pages">
            Informații la {pages.length === 1 ? 'pagina' : 'paginile'}:{' '}
            <span className="font-bold">
              {pages.map((page, index) => {
                return (
                  <span key={`page-info-${index}`}>
                    {index !== 0 && ', '}
                    {book ? (
                      <a
                        href={`https://storage.grile.info/${
                          process.env.REACT_APP_TYPE
                        }/books/${book.book_name}#page=${
                          page + book.book_page_offset
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-primary"
                      >
                        {page}
                      </a>
                    ) : (
                      page
                    )}
                  </span>
                )
              })}
            </span>
          </p>
        )}

        {gridId && userDetails?.isAdmin && (
          <p className="text-base">
            Id: <span className="font-bold">{gridId}</span>
          </p>
        )}
      </div>
    </Modal>
  )
}

export default InfoModal
